import React, { useState, useEffect, useContext } from 'react';
import RequestService from '../../services/RequestService';
import TableComponent from '../../widgets/TableComponent';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import {
    Grid2 as Grid,
    Typography,
    Breadcrumbs,
    Link,
    Stack,
    Chip,
    TextField,
    Button,
    Box,
    Snackbar,
    Alert,
    useMediaQuery,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
} from '@mui/material';
import { UserContext } from '../../contexts/UserContext';
import { useTheme } from '@mui/material/styles';
import ProductList from '../../widgets/stores/ProductList';
import RewardBadge from '../../widgets/RewardBadge';
import ImageWithFallback from '../../widgets/ImageWithFallback';

import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';
import AdminProductDialog from '../../widgets/admin/AdminProductDialog';
import AdminNewProductDialog from '../../widgets/admin/AdminNewProductDialog';
import AdminDeleteProductDialog from '../../widgets/admin/AdminDeleteProductDialog';

const AdminProductPage = () => {
    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    const { user } = useContext(UserContext);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [selectedPlayer, setSelectedProduct] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [gameId, setGameId] = useState('');
    const [games, setGames] = useState([]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        RequestService.getCompanies().then(setCompanies);
    }, []);

    const handleCompanyChange = (e) => {
        const companyId = e.target.value;
        setSelectedCompanyId(companyId);
        setProducts([]);
    };

    useEffect(() => {
        const fetchProducts = async () => {
            if (!selectedCompanyId) return;
            setLoading(true);
            try {
                const data =
                    await RequestService.getProductsAsSuperAdmin(
                        selectedCompanyId
                    );
                setProducts(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Erro ao carregar jogos:', err);
                setError('Erro ao carregar jogos.');
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        const fetchGames = async () => {
            try {
                const gameData =
                    await RequestService.getGamesAsSuperAdmin(
                        selectedCompanyId
                    );
                setGames(Array.isArray(gameData) ? gameData : []);
            } catch (err) {
                console.error('Erro ao carregar jogos:', err);
            }
        };

        fetchGames();

        fetchProducts();
    }, [selectedCompanyId]);

    // useEffect(() => {
    //     fetchProducts();
    // }, [selectedCompanyId]);

    // const fetchProducts = async () => {
    //     try {
    //         setLoading(true);

    //         const data = await RequestService.getProducts(
    //             selectedCompanyId,
    //             searchTerm,
    //             gameId
    //         );
    //         setProducts(Array.isArray(data) ? data : []);
    //     } catch (err) {
    //         setError('Erro ao carregar produtos.');
    //         setProducts([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleRowClick = (player) => {
        setSelectedProduct(player);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedProduct(null);
    };

    const handleOpenAddDialog = () => setIsAddDialogOpen(true);
    const handleCloseAddDialog = () => setIsAddDialogOpen(false);
    const handleOpenDeleteDialog = (product) => {
        setSelectedProduct(product);
        setIsDeleteDialogOpen(true);
    };

    const handleCloseDeleteDialog = () => {
        setIsDeleteDialogOpen(false);
        setSelectedProduct(null);
    };

    const handleSuccessDelete = async () => {
        const data =
            await RequestService.getProductsAsSuperAdmin(selectedCompanyId);
        setProducts(Array.isArray(data) ? data : []);
        setSnackbarMessage('Recompensa excluída com sucesso!');
        setSnackbarOpen(true);
    };

    const handleSucessProduct = async (
        message = 'Operação realizada com sucesso!'
    ) => {
        const data =
            await RequestService.getProductsAsSuperAdmin(selectedCompanyId);
        setProducts(Array.isArray(data) ? data : []);

        setSnackbarMessage(message);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const renderCompanySelect = () => (
        <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel>Empresa</InputLabel>
            <Select
                value={selectedCompanyId}
                onChange={handleCompanyChange}
                label="Empresa"
            >
                {companies.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                        {c.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );

    const renderEmptyState = () => (
        <Box sx={{ textAlign: 'center', mt: 4, color: '#666' }}>
            <Typography variant="h6">Nenhuma recompensa disponível.</Typography>
            <Typography variant="body2">
                As recompensas criadas aparecerão aqui.
            </Typography>
        </Box>
    );

    const renderMobileState = () => {
        return products.length === 0 ? (
            renderEmptyState()
        ) : (
            <ProductList
                products={products}
                onUserClick={handleRowClick}
                onDeleteClick={handleOpenDeleteDialog}
            />
        );
    };

    const renderDesktopState = () => {
        return products.length === 0 ? (
            renderEmptyState()
        ) : (
            <Grid container justifyContent="center" xs={12}>
                <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
                    <TableComponent columns={columns} rows={products} />
                </Box>
            </Grid>
        );
    };

    const columns = [
        {
            label: 'Imagem',
            field: 'photo',
            align: 'center',
            renderCell: (value, row) => (
                <Box
                    sx={{
                        width: 172,
                        height: 112,
                        overflow: 'hidden',
                        borderRadius: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid #E0E0E0',
                        backgroundColor: '#FFFFFF',
                    }}
                >
                    <ImageWithFallback
                        src={row.photoUrl}
                        alt={row.name}
                        fallbackSrc="../../assets/images/gameup_dark.png"
                        styles={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </Box>
            ),
        },
        {
            label: 'Título, Descrição e Custo',
            field: 'actions',
            align: 'left',
            renderCell: (value, row, stopPropagation) => (
                <Stack direction="column" spacing={1}>
                    <Typography variant="body2" sx={{ color: '#292929' }}>
                        {row.name}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ fontSize: '14px', color: '#292929' }}
                    >
                        {row.description}
                    </Typography>
                    <RewardBadge
                        icon={
                            <CoinIcon
                                style={{ color: '#134F99', fontSize: '24px' }}
                            />
                        }
                        value={row.price}
                    />
                </Stack>
            ),
        },
        {
            label: 'Quantidade',
            field: 'quantity',
            align: 'center',
        },
        {
            label: 'Jogos',
            field: 'games',
            align: 'center',
            renderCell: (value, row) => (
                <Stack direction="column" spacing={1}>
                    {row.games.map((game, index) => (
                        <Chip
                            key={index}
                            label={game.name}
                            size="small"
                            color="primary"
                        />
                    ))}
                </Stack>
            ),
        },
        {
            label: 'Status',
            field: 'status',
            align: 'center',
            renderCell: (value, row) => (
                <Chip
                    label={row.quantity > 0 ? 'Disponível' : 'Indisponível'}
                    size="small"
                    color={row.quantity > 0 ? '#97CC04' : '#CCCCCC'}
                />
            ),
        },
        {
            label: '',
            field: 'actions',
            align: 'right',
            renderCell: (value, row, stopPropagation) => (
                <Stack direction="row" spacing={2}>
                    <Link
                        component="button"
                        onClick={(event) => {
                            stopPropagation(event);
                            setSelectedProduct(row);
                            setIsDialogOpen(true);
                        }}
                        underline="none"
                        className="action-link"
                    >
                        <Stack direction="row" spacing={1} alignItems="center">
                            <EditOutlinedIcon
                                fontSize="small"
                                color="#1F83FF"
                            />
                            <Typography>Editar</Typography>
                        </Stack>
                    </Link>
                    <Link
                        component="button"
                        onClick={() => handleOpenDeleteDialog(row)}
                        underline="none"
                        className="action-link"
                        sx={{ color: 'red' }}
                    >
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            color="#1F83FF"
                        >
                            <DeleteOutlinedIcon fontSize="small" />
                            <Typography>Excluir</Typography>
                        </Stack>
                    </Link>
                </Stack>
            ),
        },
    ];

    return (
        <Box>
            <Grid container justifyContent="start">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                        Início
                    </Link>
                    <Link underline="hover" color="inherit">
                        Loja
                    </Link>
                    <Typography sx={{ color: 'text.primary' }}>
                        Recompensas
                    </Typography>
                </Breadcrumbs>
            </Grid>

            <Grid container xs={12} sx={{ mt: 3 }}>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: 24,
                        fontWeight: '500',
                        color: '#0C3466',
                        mb: 2,
                    }}
                >
                    Recompensas
                </Typography>
            </Grid>

            <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                wrap="wrap"
            >
                {/* Right side: “Nova Missão” button */}
                <Grid item xs={12} md="auto">
                    <Button
                        variant="contained"
                        sx={{ minHeight: '47px' }}
                        endIcon={<AddCircleOutlineOutlinedIcon />}
                        onClick={handleOpenAddDialog}
                    >
                        Nova Recompensa
                    </Button>
                </Grid>
            </Grid>

            {/* <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Pesquisar Nome"
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                fetchProducts(); // Fetch when pressing Enter
                            }
                        }}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl
                        sx={{ minWidth: 200, width: '100%' }}
                        fullWidth
                    >
                        <InputLabel>Filtrar por Jogo</InputLabel>
                        <Select
                            value={gameId}
                            onChange={(e) => {
                                setGameId(e.target.value);
                                fetchProducts(); // Fetch immediately when changing filter
                            }}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {games.map((game) => (
                                <MenuItem key={game.id} value={game.id}>
                                    {game.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        sx={{ minHeight: '47px' }}
                        onClick={fetchProducts}
                        fullWidth
                    >
                        Aplicar Filtros
                    </Button>
                    <Grid item sx={12}>
                        <Button
                            variant="contained"
                            sx={{ minHeight: '47px' }}
                            endIcon={<AddCircleOutlineOutlinedIcon />}
                            onClick={handleOpenAddDialog}
                        >
                            Nova Recompensa
                        </Button>
                    </Grid>
                </Grid>
            </Grid> */}

            {renderCompanySelect()}

            {loading ? (
                <Stack alignItems="center" mt={4}>
                    <CircularProgress />
                </Stack>
            ) : isMobile ? (
                renderMobileState()
            ) : (
                renderDesktopState()
            )}

            <AdminProductDialog
                open={isDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDialog();
                    }
                }}
                onSuccess={handleSucessProduct}
                product={selectedPlayer}
                company={selectedCompanyId}
            />

            <AdminNewProductDialog
                open={isAddDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseAddDialog();
                    }
                }}
                onSuccess={handleSucessProduct}
                company={selectedCompanyId}
            />

            <AdminDeleteProductDialog
                open={isDeleteDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDeleteDialog();
                    }
                }}
                product={selectedPlayer}
                onSuccess={handleSuccessDelete}
            />

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity="success"
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default AdminProductPage;
